<template>
	<div>
		<h1>{{message}}</h1>
		<h2><a :href="`mailto:${email}`">{{email}}</a></h2>
	</div>
</template>

<script>
export default {
	data() {
		return {
			message: "Anders Wikström",
			email: "anders@anderswikstrom.se"
		}
	}
}
</script>

<style scoped>
	a {
		color: #2c3e50;
	}

	div {
		background-color: white;
		display: inline-block;
		padding: 1em 2em;
		box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
	}

	h2 {
		font-size: 1em;
	}

	h2 a:hover {
		color: #6b7988;
	}
</style>